/**
 * Canonical list of student math-keyboard ids — the single source of truth, kept free of any
 * `mathlive` coupling so schemas and studio UI can import it without pulling the (heavy, lazily
 * loaded) editor into their bundles. The matching `VirtualKeyboardLayout` objects live in
 * `packages/shared/src/components/MathLiveField/mathKeyboardLayouts.ts`. Like `MATH_POLICY_IDS`,
 * `core` imports these directly from `shared`, so there is no duplicate to keep in sync.
 */
export const MATH_KEYBOARD_IDS = ['algebraicNumeric', 'geometric'] as const;

export type MathKeyboardId = (typeof MATH_KEYBOARD_IDS)[number];

export const DEFAULT_MATH_KEYBOARD: MathKeyboardId = 'algebraicNumeric';
